/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { getUproColor } from "utils/colors";
import { makeNiceText } from "utils/formatters";

function calculo(operador, num1, num2) {
  switch (operador) {
    case "add":
      return num1 + num2;
    case "remove":
      return num1 - num2;
    default:
      return 0;
  }
}

const getRows = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: (
          <SoftBox
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftBox pl={3} mr={2}>
              <Tooltip
                title={item?.disabled ? item?.tipo + "deshabilitado" : item?.tipo}
                placement="top"
              >
                <Icon
                  sx={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    color: item?.disabled
                      ? getUproColor()
                      : item.tipo === "Material"
                        ? getUproColor("uproYellow")
                        : item.tipo === "Consumible"
                          ? getUproColor("uproGreen")
                          : getUproColor("uproPink"),
                  }}
                  fontSize="lg"
                >
                  {item?.tipo === "Material" ? "category" : "recycling"}
                </Icon>
              </Tooltip>
            </SoftBox>
          </SoftBox>
        ),
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.nombre.length > 70
                ? makeNiceText(item?.nombre).slice(0, 70) + "..."
                : makeNiceText(item?.nombre)}
              {item?.disabled && (
                <SoftTypography
                  verticalAlign="text-top"
                  variant="caption"
                  color="error"
                  fontWeight="medium"
                  sx={{ cursor: "pointer" }}
                >
                  &nbsp; (Deshabilitado)
                </SoftTypography>
              )}
            </SoftTypography>
          </SoftBox>
        ),
        categoria: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.categoria ? makeNiceText(item?.categoria) : "Sin rubro"}
            </SoftTypography>
          </SoftBox>
        ),
        stock: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {`${item?.stock?.cantidad / item?.tipoUnidad?.multiplicador || 0} ${item?.tipoUnidad?.abreviatura
                }`}
            </SoftTypography>
          </SoftBox>
        ),
        consumo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftBadge
              size="xs"
              color={item?.operation === "add" ? "success" : "error"}
              badgeContent={
                <SoftTypography
                  verticalAlign="text-top"
                  variant="caption"
                  fontWeight="medium"
                  color="white"
                >
                  {`${item?.operation === "add" ? "+" : "-"}${item?.cantidad / item?.tipoUnidad?.multiplicador || 0} ${item?.tipoUnidad?.abreviatura
                    }`}
                </SoftTypography>
              }
            />
          </SoftBox>
        ),
        stockNew: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {calculo(item?.operation, item?.stock?.cantidad / item?.tipoUnidad?.multiplicador || 0, item?.cantidad / item?.tipoUnidad?.multiplicador || 0)}
            </SoftTypography>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "ID", width: "1%", align: "left" },
  { name: "nombre", desc: "Nombre", align: "left", width: "30%" },
  { name: "categoria", desc: "Rubro", align: "left" },
  { name: "stock", desc: "Stock anterior", align: "center", width: "1%" },
  { name: "consumo", desc: "Ajuste", align: "center", width: "1%" },
  { name: "stockNew", desc: "Stock nuevo", align: "center", width: "1%" },
];

export default { columns, getRows };
